var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"width":"510px","visible":_vm.visible},on:{"close":function($event){return _vm.$emit('update:visible', false)}}},[_c('upload-list',{ref:"uploadList",attrs:{"preview":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }